import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import OwlSlider from "./Sliders/OwlSlider";
import NewArrivalSlider from "./Sliders/NewArrivalSlider";
import CorporateGiftingSlider from "./Sliders/CorporateGiftingSlider";
import BestSellersSlider from "./Sliders/BestSellersSlider";
import PopularProductSlider from "./Sliders/PopularProductSlider";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "./features/productSlice";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { fetchLocation } from "./features/currencylistSlice";
import GlobalDelivery from "../assets/images/states/GlobalDel.mp4";
import Carousel from "./Sliders/Carousel";
import freshIcon from "../assets/images/icons/Fresh arrivals.png";
import bestIcon from "../assets/images/icons/Best sellers.png";
import popularIcon from "../assets/images/icons/popular.png";
// import Category from "./Category";
// Add custom CSS for state coverage section
const stateCardStyles = {
  ".state-card": {
    position: "relative",
    transition: "transform 0.3s ease-in-out",
    cursor: "pointer",
  },
  ".state-card:hover": {
    transform: "scale(1.05)",
  },
  ".state-overlay": {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(91, 75, 136, 0.7)",
    opacity: 0,
    transition: "opacity 0.3s ease-in-out",
  },
  ".state-card:hover .state-overlay": {
    opacity: 1,
  },
};

// Add styles to document
const styleSheet = document.createElement("style");
styleSheet.textContent = Object.entries(stateCardStyles)
  .map(
    ([selector, rules]) =>
      `${selector} { ${Object.entries(rules)
        .map(([property, value]) => `${property}: ${value};`)
        .join(" ")} }`
  )
  .join("\n");
document.head.appendChild(styleSheet);

const Home = () => {
  const [catList, setCatList] = useState([]);
  const [giftList, setGiftList] = useState([]);
  const [giftloading, setgiftloading] = useState(true);
  const [banner, setBanner] = useState({});
  const dispatch = useDispatch();
  const { bestSellerProducts, arrivalProducts, popularProducts } = useSelector(
    (state) => state.product
  );
  const user = useSelector((state) => state.auth.user);

  // const fetchgiftingList = async () => {
  //   setgiftloading(true);
  //   try {
  //     const res = await fetch(
  //       `${process.env.REACT_APP_BACKEND_URL}/api/hampers`,
  //       {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     const data = await res.json();
  //     if (data.success) {
  //       // console.log("corporate gifting data", data.responseObject);
  //       setGiftList(data.responseObject);
  //     } else {
  //       // console.log("Error fetching gift data:", data.message);
  //     }
  //     setgiftloading(false);
  //   } catch (error) {
  //     // console.log("error fetch gift", error);
  //     setgiftloading(false);
  //   }
  // };

  const fetchCategories = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/categories`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = await res.json();
      // console.log("data", data);
      setCatList(data.responseObject);
    } catch (error) {
      // console.log("fetch cat error", error.response);
    }
  };

  const fetchBannerList = async () => {
    setgiftloading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/bottom-banners`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await res.json();
      setBanner(data.responseObject);
      setgiftloading(false);
    } catch (error) {
      // console.log("error fetch gift", error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    // fetchgiftingList();
    fetchCategories();
    fetchBannerList();
    dispatch(fetchProducts());
    dispatch(fetchLocation());
    // dispatch(fetchCurrencyRates());
  }, [dispatch, user]);

  if (!arrivalProducts.length) {
    return;
  }

  if (!bestSellerProducts) {
    return;
  }
  if (!popularProducts) {
    return;
  }
  if (giftloading) {
    return;
  }
  const options = {
    loop: arrivalProducts?.length > 5 ? true : false,
    // loop: true,
    margin: 10,
    autoplayHoverPause: true,
    dots: false,
    autoplay: true,
    responsive: {
      0: {
        items: 1,
        nav: false,
      },
      576: {
        items: 2,
        nav: false,
      },
      768: {
        items: 3,
        nav: false,
      },
      992: {
        items: 4,
        nav: false,
      },
      1200: {
        items: 5,
        nav: false,
      },
    },
  };
  const options2 = {
    loop: popularProducts?.length > 5 ? true : false,
    margin: 10,
    autoplayHoverPause: true,
    dots: false,
    autoplay: true,
    items: 5,
    responsive: {
      0: {
        items: 1,
        nav: false,
      },
      576: {
        items: 2,
        nav: false,
      },
      768: {
        items: 3,
        nav: false,
      },
      992: {
        items: 4,
        nav: false,
      },
      1200: {
        items: 5,
        nav: false,
      },
    },
  };
  const options3 = {
    loop: bestSellerProducts?.length > 5 ? true : false,
    margin: 10,
    autoplayHoverPause: true,
    nav: false,
    dots: false,
    autoplay: true,
    items: 5,
    responsive: {
      0: {
        items: 1,
        nav: false,
      },
      576: {
        items: 2,
        nav: false,
      },
      768: {
        items: 3,
        nav: false,
      },
      992: {
        items: 4,
        nav: false,
      },
      1200: {
        items: 5,
        nav: false,
      },
    },
  };
  const options1 = {
    loop: giftList.length > 4 ? true : false,
    margin: 10,
    autoplay: true,
    autoplayHoverPause: true,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 1,
        nav: false,
        margin: 10,
        stagePadding: 0,
      },
      480: {
        items: 1,
        nav: false,
        margin: 15,
        stagePadding: 30,
      },
      576: {
        items: 1,
        nav: false,
        margin: 15,
        stagePadding: 50,
      },
      768: {
        items: 2,
        nav: false,
        margin: 20,
        stagePadding: 0,
      },
      992: {
        items: 3,
        nav: false,
        margin: 25,
      },
      1200: {
        items: 4,
        nav: false,
        margin: 30,
      },
    },
  };

  return (
    <>
      <Helmet>
        <title>Sweetz - Delicious Indian Sweets & Snacks</title>
        <meta
          name="description"
          content="Discover authentic Indian sweets and snacks. Fresh arrivals, bestsellers, and popular treats delivered to your doorstep. Shop our wide selection of traditional and modern Indian delicacies."
        />
        <meta
          name="keywords"
          content="Indian sweets, Indian snacks, traditional sweets, online sweets shop, fresh sweets delivery"
        />

        {/* Essential OpenGraph Tags */}
        <meta
          property="og:title"
          content="Sweetz - Delicious Indian Sweets & Snacks"
        />
        <meta
          property="og:description"
          content="Discover authentic Indian sweets and snacks. Fresh arrivals, bestsellers, and popular treats delivered to your doorstep."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.origin} />
        <meta
          property="og:image"
          content={`https://res.cloudinary.com/damoxae5y/image/upload/v1741935873/snslogo_v202wa.png`}
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Sweetz" />
        <meta property="og:locale" content="en_US" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Sweetz - Delicious Indian Sweets & Snacks"
        />
        <meta
          name="twitter:description"
          content="Discover authentic Indian sweets and snacks. Fresh arrivals, bestsellers, and popular treats delivered to your doorstep."
        />
        <meta
          name="twitter:image"
          content={`https://res.cloudinary.com/damoxae5y/image/upload/v1741935873/snslogo_v202wa.png`}
        />

        {/* Canonical URL */}
        <link rel="canonical" href={window.location.origin} />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Sweetz",
            url: window.location.origin,
            description:
              "Discover authentic Indian sweets and snacks. Fresh arrivals, bestsellers, and popular treats delivered to your doorstep.",
            potentialAction: {
              "@type": "SearchAction",
              target: {
                "@type": "EntryPoint",
                urlTemplate: `${window.location.origin}/shop?search={search_term_string}`,
              },
              "query-input": "required name=search_term_string",
            },
          })}
        </script>
      </Helmet>

      {/* category section starts */}
      <section className="category-sec">
        <div
          className="container"
          style={{
            maxWidth: "900px",
          }}
        >
          <div
            style={{
              overflowX: "auto",
              WebkitOverflowScrolling: "touch",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            <div
              className="img-container"
              style={{
                display: "flex",
                gap: "2px",
                padding: "10px 30px",
                minWidth: "100%",
              }}
            >
              {catList
                .filter((cat) => cat.isAvailable)
                .map((cat) => (
                  <Link
                    to={`/view-all?category=${cat._id}`}
                    key={cat._id}
                    style={{ textDecoration: "none", width: "175px" }}
                  >
                    <div
                      className="category-item"
                      style={{
                        margin: "0 auto",
                      }}
                    >
                      <div className="category-image-container">
                        <img
                          src={`${cat.categoryImages}`}
                          alt={cat.categoryName}
                          className="category-image"
                          style={{
                            width: "75px",
                            height: "75px",
                          }}
                        />
                      </div>
                      <h5 className="category-title">
                        {cat.categoryName.split(" ").map((word, index) => (
                          <div key={index}>{word}</div>
                        ))}
                      </h5>
                    </div>
                  </Link>
                ))}
            </div>
          </div>
        </div>
        <style>
          {`
            .category-sec {
              position: relative;
              margin-top: 150px; /* Default top margin */
            }
            
            @media (max-width: 770px) {
              .category-sec {
                margin-top: 100px; /* Top margin for screens below 768px */
              }
              .img-container{
                align-items: "center",
                justify-content: "center"
              }
              
            }
            @media (max-width: 500px) {
              .category-sec {
                margin-top: 50px; /* Top margin for screens below 768px */
              }
            }

            .category-item {
              width: 100px;
              text-align: center;
              transition: transform 0.3s ease;
              cursor: pointer;
              flex-shrink: 0; /* Prevent items from shrinking */
            }

            .category-image-container {
              height: auto;
              margin: 0 auto 0;
              transition: all 0.3s ease;
              position: relative;
              overflow: hidden;
            }

            .category-image {
              width: 60%;
              height: 60%;
              object-fit: cover;
              border-radius: 50%;
            }

            .category-title {
              font-size: 0.8rem;
              color: #3c3260;
              margin: 5px 0;
              font-weight: 500;
              font-size: 0.7rem;
            }

            /* Tablet styles */
            @media (max-width: 768px) {
              .category-image-container {
                padding: 12px;
              }
              .category-title {
                font-size: 0.7rem;
              }
            }

            /* Mobile styles */
            @media (max-width: 576px) {
              .category-title {
                font-size: 0.7rem;
              }
            }
            /* Hover effects */
            .category-image-container:hover {
              transform: translateY(-10px);
            }
            
            /* Hide scrollbar for Chrome, Safari and Opera */
            .category-sec div::-webkit-scrollbar {
              display: none;
            }
            
            /* Add gradient indicators for scroll */
            @media (max-width: 991px) {
              .category-sec::after {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                height: 100%;
                width: 50px;
                background: linear-gradient(to left, #faf7ff 0%, transparent 100%);
                pointer-events: none;
              }
              
              .category-sec::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 50px;
                background: linear-gradient(to right, #faf7ff 0%, transparent 100%);
                pointer-events: none;
                z-index: 1;
              }
            }

            /* Center scrolling for mobile */
            @media (max-width: 991px) {
              .category-sec .container > div > div {
                gap: 15px;
                justify-content: flex-start; /* Allow natural scrolling on mobile */
              }
            }

            /* Ensure proper centering on desktop */
            @media (min-width: 992px) {
              .category-sec .container > div > div {
                flex-wrap: nowrap;
                justify-content: center;
              }
            }
          `}
        </style>
      </section>
      {/* category section ends */}

      <OwlSlider />

      {/* Horizontal Scroll Section start */}
      {/* Horizontal Scroll Section end */}

      {/* State Coverage Section start */}
      {/* <StateCoverageSlider /> */}
      <Carousel />
      {/* State Coverage Section end */}

      {/* new arrival section start*/}
      <section
        className="product-sec tp-space"
        style={{ background: "#faf7ff" }}
      >
        <div className="container">
          <div className="row justify-content-center mb-2">
            <div className="col-lg-6 text-center">
              <div className="section-title">
                <span
                  className="subtitle"
                  style={{
                    color: "#3c3260",
                    letterSpacing: "2px",
                    fontSize: "14px",
                  }}
                >
                  A Fresh Twist on Authentic Taste!
                </span>
                <h2 className="title mt-2 mb-3">
                  Fresh <span style={{ color: "#3c3260" }}>Arrivals</span>
                </h2>
                <div className="title-divider">
                  <div className="divider-icon" style={{ color: "#3c3260" }}>
                    <img
                      src={freshIcon}
                      alt="cookie"
                      style={{
                        width: "40px",
                        height: "40px",
                      }}
                    />
                  </div>
                </div>
                <p className="text-muted mt-3">
                  {/* Discover our latest collection of delightful treats and sweets */}
                  Explore our newest fusion of sweets and snacks
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="position-relative">
                <OwlCarousel
                  className="product-slide owl-theme owl-carousel"
                  {...options}
                >
                  {arrivalProducts &&
                    arrivalProducts.map((product) => (
                      <NewArrivalSlider
                        key={product._id}
                        product={product}
                        user={user}
                      />
                    ))}
                </OwlCarousel>

                <div className="text-center mt-4">
                  <Link
                    to="/view-all?type=arrivals"
                    className="custom-btn bg-btn"
                    style={{
                      padding: "12px 30px",
                      borderRadius: "25px",
                      textTransform: "uppercase",
                      fontSize: "14px",
                      letterSpacing: "1px",
                      fontWeight: "500",
                      boxShadow: "0 4px 15px rgba(91, 75, 136, 0.2)",
                      transition: "all 0.3s ease",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <span>View More</span>
                    <i className="fas fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add decorative elements */}
        <div className="section-decorations">
          <div
            className="decoration-left"
            style={{
              position: "absolute",
              left: "0",
              top: "50%",
              transform: "translateY(-50%)",
              opacity: "0.1",
            }}
          >
            <i className="fas fa-cookie fa-4x" style={{ color: "#3c3260" }}></i>
          </div>
          <div
            className="decoration-right"
            style={{
              position: "absolute",
              right: "0",
              top: "50%",
              transform: "translateY(-50%)",
              opacity: "0.1",
            }}
          >
            <i className="fas fa-cookie fa-4x" style={{ color: "#3c3260" }}></i>
          </div>
        </div>
      </section>
      {/* new arrival section end*/}

      {/* 2nd Advertisement Banner  */}
      <section
        className="sale-sec"
        style={{
          position: "relative",
          width: "100vw",
          marginLeft: "calc(-50vw + 50%)",
          marginRight: "calc(-50vw + 50%)",
          height: "auto",
          maxHeight: "500px",
        }}
      >
        <div className="container-fluid p-0">
          <div className="row g-0">
            <div className="col-12">
              <Link to={`${banner?.data?.redirectUrl_4 ?? "/shop"}`}>
                <img
                  src={banner?.data?.imageUrl_4}
                  alt="Sale Banner"
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                    objectFit: "contain",
                    objectPosition: "center",
                    backgroundColor: "#fff",
                    maxHeight: "500px",
                  }}
                />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/*  Bestsellers section start */}
      <section className="product-sec tp-space" style={{ background: "#fff" }}>
        <div className="container">
          <div className="row justify-content-center mb-4">
            <div className="col-lg-6 text-center">
              <div className="section-title">
                <span
                  className="subtitle"
                  style={{
                    color: "#3c3260",
                    letterSpacing: "2px",
                    fontSize: "14px",
                  }}
                >
                  {/* CUSTOMER FAVORITES */}
                  Most Loved by Customers!
                </span>
                <h2 className="title mt-2 mb-3">
                  Best <span style={{ color: "#3c3260" }}>Sellers</span>
                </h2>
                <div className="title-divider">
                  <div className="divider-icon" style={{ color: "#3c3260" }}>
                    <img
                      src={bestIcon}
                      alt="best"
                      style={{
                        width: "45px",
                        height: "45px",
                      }}
                    />
                  </div>
                </div>
                <p className="text-muted mt-3">
                  {/* Our most loved and highly rated sweet delicacies */}
                  Discover our most loved delicacies
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="position-relative">
                <OwlCarousel
                  className="product-slide owl-theme owl-carousel"
                  {...options3}
                >
                  {bestSellerProducts &&
                    bestSellerProducts.map((product) => (
                      <BestSellersSlider
                        key={product._id}
                        product={product}
                        user={user}
                      />
                    ))}
                </OwlCarousel>

                <div className="text-center mt-4">
                  <Link
                    to="/view-all?type=bestsellers"
                    className="custom-btn bg-btn"
                    style={{
                      padding: "12px 30px",
                      borderRadius: "25px",
                      textTransform: "uppercase",
                      fontSize: "14px",
                      letterSpacing: "1px",
                      fontWeight: "500",
                      boxShadow: "0 4px 15px rgba(91, 75, 136, 0.2)",
                      transition: "all 0.3s ease",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <span>Explore Bestsellers</span>
                    <i className="fas fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section-decorations">
          <div
            className="decoration-left"
            style={{
              position: "absolute",
              left: "0",
              top: "50%",
              transform: "translateY(-50%)",
              opacity: "0.1",
            }}
          >
            <i className="fas fa-award fa-4x" style={{ color: "#3c3260" }}></i>
          </div>
          <div
            className="decoration-right"
            style={{
              position: "absolute",
              right: "0",
              top: "50%",
              transform: "translateY(-50%)",
              opacity: "0.1",
            }}
          >
            <i className="fas fa-award fa-4x" style={{ color: "#3c3260" }}></i>
          </div>
        </div>
      </section>
      {/* Bestsellers section end */}

      {/* Sale banner section start */}
      <section
        className="sale-sec tp-space  "
        style={{
          background: "linear-gradient(135deg, #faf7ff 0%, #f5f0ff 100%)",
          padding: "70px 0",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative background elements */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            opacity: 0.03,
            backgroundImage: "radial-gradient(#3c3260 1px, transparent 1px)",
            backgroundSize: "20px 20px",
          }}
        />

        {/* Animated decorative elements */}
        <div
          style={{
            position: "absolute",
            top: "15%",
            left: "2%",
            width: "80px",
            height: "80px",
            opacity: 0.1,
            background: "#3c3260",
            clipPath:
              "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
            animation: "floatLeft 8s ease-in-out infinite",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "15%",
            right: "2%",
            width: "60px",
            height: "60px",
            opacity: 0.1,
            background: "#3c3260",
            borderRadius: "50%",
            animation: "floatRight 6s ease-in-out infinite",
          }}
        />

        <div className="container ">
          <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div
                style={{
                  position: "relative",
                  borderRadius: "25px",
                  overflow: "hidden",
                  boxShadow: "0 15px 40px rgba(91, 75, 136, 0.15)",
                  transition: "all 0.4s ease",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.boxShadow =
                    "0 20px 50px rgba(91, 75, 136, 0.2)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 15px 40px rgba(91, 75, 136, 0.15)";
                }}
              >
                <Link to={`${banner?.data?.redirectUrl_3 ?? "/shop"}`}>
                  <div
                    style={{
                      position: "relative",
                      overflow: "hidden",
                      borderRadius: "25px",
                    }}
                  >
                    <img
                      src={banner?.data?.imageUrl_3}
                      alt="Sale Banner"
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                        transition: "transform 0.5s ease",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                    {/* Subtle overlay gradient */}
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background:
                          "linear-gradient(180deg, rgba(91, 75, 136, 0) 0%, rgba(91, 75, 136, 0.08) 100%)",
                        transition: "opacity 0.3s ease",
                      }}
                    />

                    {/* Shine effect on hover */}
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: "-100%",
                        width: "50%",
                        height: "100%",
                        background:
                          "linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)",
                        transform: "skewX(-25deg)",
                        animation: "shine 3s infinite",
                      }}
                    />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Add keyframes for animations */}
        <style>
          {`
            @keyframes shine {
              0% { left: -100%; }
              20% { left: 100%; }
              100% { left: 100%; }
            }
          `}
        </style>
      </section>
      {/* Sale banner section end */}

      {/* Popular Products section start */}
      <section
        className="product-sec tp-space"
        style={{ background: "#faf7ff" }}
      >
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-6 text-center">
              <div className="section-title">
                <span
                  className="subtitle"
                  style={{
                    color: "#3c3260",
                    letterSpacing: "2px",
                    fontSize: "14px",
                  }}
                >
                  TRENDING NOW
                </span>
                <h2 className="title mt-2 mb-3">
                  Popular <span style={{ color: "#3c3260" }}>Products</span>
                </h2>
                <div className="title-divider">
                  <div className="divider-icon" style={{ color: "#3c3260" }}>
                    {/* <i className="fas fa-heart"></i> */}
                    <img
                      src={popularIcon}
                      alt="best"
                      style={{
                        width: "40px",
                        height: "48px",
                      }}
                    />
                  </div>
                </div>
                <p className="text-muted mt-3">
                  Discover the most loved and craved treats
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="position-relative">
                <OwlCarousel
                  className="product-slide owl-theme owl-carousel"
                  {...options2}
                >
                  {popularProducts &&
                    popularProducts.map((product) => (
                      <PopularProductSlider
                        key={product._id}
                        product={product}
                        user={user}
                      />
                    ))}
                </OwlCarousel>

                <div className="text-center mt-4">
                  <Link
                    to="/view-all?type=popular"
                    className="custom-btn bg-btn"
                    style={{
                      padding: "12px 30px",
                      borderRadius: "25px",
                      textTransform: "uppercase",
                      fontSize: "14px",
                      letterSpacing: "1px",
                      fontWeight: "500",
                      boxShadow: "0 4px 15px rgba(91, 75, 136, 0.2)",
                      transition: "all 0.3s ease",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <span>View Popular Items</span>
                    <i className="fas fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section-decorations">
          <div
            className="decoration-left"
            style={{
              position: "absolute",
              left: "0",
              top: "50%",
              transform: "translateY(-50%)",
              opacity: "0.1",
            }}
          >
            <i className="fas fa-fire fa-4x" style={{ color: "#3c3260" }}></i>
          </div>
          <div
            className="decoration-right"
            style={{
              position: "absolute",
              right: "0",
              top: "50%",
              transform: "translateY(-50%)",
              opacity: "0.1",
            }}
          >
            <i className="fas fa-fire fa-4x" style={{ color: "#3c3260" }}></i>
          </div>
        </div>
      </section>
      {/* Popular Products section end */}

      {/* Corporate Gifting section start (hide for now by using display:none) */}
      <section
        className="corparate-sec tp-space"
        style={{ background: "#fff", position: "relative", display: "none" }}
      >
        {/* Add decorative background elements */}
        <div
          className="gift-bg-element"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            opacity: 0.05,
            backgroundImage:
              "repeating-linear-gradient(45deg, #3c3260 0, #3c3260 1px, transparent 0, transparent 50%)",
            backgroundSize: "10px 10px",
            pointerEvents: "none",
          }}
        />

        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-6 text-center">
              <div className="section-title">
                <span
                  className="subtitle"
                  style={{
                    color: "#3c3260",
                    letterSpacing: "2px",
                    fontSize: "14px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <i className="fas fa-gift"></i>
                  CORPORATE DELIGHTS!
                </span>
                <h2 className="title mt-2 mb-3">
                  Corporate <span style={{ color: "#3c3260" }}>Gifting</span>
                </h2>
                <div className="title-divider">
                  <div className="divider-icon" style={{ color: "#3c3260" }}>
                    <i className="fas fa-briefcase"></i>
                  </div>
                </div>
                <p className="text-muted mt-3">
                  Perfect gifting solutions for your corporate events and
                  celebrations
                </p>
              </div>
            </div>
          </div>

          {/* Add info cards above the slider */}
          <div className="row mb-5">
            {[
              {
                icon: "fas fa-box-open",
                title: "Customized Packaging",
                description: "Branded packaging solutions",
              },
              {
                icon: "fas fa-truck",
                title: "Bulk Orders",
                description: "Efficient bulk order handling",
              },
              {
                icon: "fas fa-tags",
                title: "Special Pricing",
                description: "Competitive corporate rates",
              },
              {
                icon: "fas fa-handshake",
                title: "Dedicated Support",
                description: "Personal account manager",
              },
            ].map((feature, index) => (
              <div key={index} className="col-6 col-md-6 col-lg-3 mb-4">
                <div
                  className="corporate-feature-card"
                  style={{
                    padding: "15px",
                    borderRadius: "10px",
                    background: "#faf7ff",
                    textAlign: "center",
                    transition: "transform 0.3s ease",
                    cursor: "pointer",
                    height: "100%",
                    boxShadow: "0 2px 8px rgba(91, 75, 136, 0.1)",
                  }}
                >
                  <i
                    className={`${feature.icon} fa-2x mb-2 mb-md-3`}
                    style={{ color: "#3c3260" }}
                  ></i>
                  <h5
                    style={{
                      fontSize: "16px",
                      marginBottom: "8px",
                      "@media (min-width: 768px)": {
                        fontSize: "18px",
                        marginBottom: "10px",
                      },
                    }}
                  >
                    {feature.title}
                  </h5>
                  <p
                    className="text-muted"
                    style={{
                      fontSize: "12px",
                      "@media (min-width: 768px)": {
                        fontSize: "14px",
                      },
                    }}
                  >
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Carousel section */}
          <div
            className="position-relative"
            style={{
              padding: "0 10px", // Add padding for mobile devices
              margin: "0 -10px", // Compensate for padding
              "@media (min-width: 768px)": {
                padding: "0 15px",
                margin: "0 -15px",
              },
            }}
          >
            {giftloading ? (
              <div className="text-center py-5">
                <div
                  className="spinner-border"
                  style={{ color: "#3c3260" }}
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <OwlCarousel
                key={giftList.length}
                className="corporate-slide owl-theme owl-carousel"
                {...options1}
              >
                {giftList.map((product) => (
                  <div
                    key={product._id}
                    style={{
                      padding: "10px", // Add padding around each slide
                      "@media (min-width: 768px)": {
                        padding: "15px",
                      },
                    }}
                  >
                    <CorporateGiftingSlider product={product} user={user} />
                  </div>
                ))}
              </OwlCarousel>
            )}
          </div>
        </div>

        {/* Add floating decorative elements */}
        <div className="section-decorations">
          <div
            className="decoration-left"
            style={{
              position: "absolute",
              left: "30px",
              top: "50%",
              transform: "translateY(-50%)",
              opacity: "0.1",
            }}
          >
            <i className="fas fa-gift fa-5x" style={{ color: "#3c3260" }}></i>
          </div>
          <div
            className="decoration-right"
            style={{
              position: "absolute",
              right: "30px",
              top: "50%",
              transform: "translateY(-50%)",
              opacity: "0.1",
            }}
          >
            <i className="fas fa-boxes fa-5x" style={{ color: "#3c3260" }}></i>
          </div>
        </div>
      </section>
      {/* Corporate Gifting section end */}

      {/* new arrival section start*/}
      {/* <NewArrivalSlider sliderData={memoizedData.sliderData} /> */}
      {/* new arrival section end*/}

      {/* Advertisement section start */}
      {/* <section
        className="advertisement-sec tp-space"
        style={{
          background: "linear-gradient(135deg, #faf7ff 0%, #f5f0ff 100%)",
          padding: "70px 0",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            opacity: 0.03,
            backgroundImage: "radial-gradient(#3c3260 1px, transparent 1px)",
            backgroundSize: "20px 20px",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "10%",
            left: "5%",
            width: "50px",
            height: "50px",
            background: "#3c3260",
            opacity: 0.1,
            borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70%",
            animation: "float 6s ease-in-out infinite",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "10%",
            right: "5%",
            width: "70px",
            height: "70px",
            background: "#3c3260",
            opacity: 0.1,
            borderRadius: "70% 30% 30% 70% / 70% 70% 30% 30%",
            animation: "float 8s ease-in-out infinite",
          }}
        />

        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-6 text-center">
              <h2
                style={{
                  color: "#3c3260",
                  fontSize: "32px",
                  fontWeight: "600",
                  marginBottom: "15px",
                }}
              >
                Special Offers
              </h2>
              <div
                style={{
                  width: "60px",
                  height: "3px",
                  background: "#3c3260",
                  margin: "0 auto",
                  marginBottom: "20px",
                }}
              />
            </div>
          </div>

          <div className="row justify-content-center g-4">
            {[
              {
                redirectUrl: banner?.data?.redirectUrl_1,
                imageUrl: banner?.data?.imageUrl_1,
                alt: "Advertisement 1",
              },
              {
                redirectUrl: banner?.data?.redirectUrl_2,
                imageUrl: banner?.data?.imageUrl_2,
                alt: "Advertisement 2",
              },
            ].map((item, index) => (
              <div key={index} className="col-lg-6 col-md-6 col-sm-12">
                <div
                  style={{
                    position: "relative",
                    borderRadius: "20px",
                    overflow: "hidden",
                    boxShadow: "0 10px 30px rgba(91, 75, 136, 0.1)",
                    transition: "all 0.3s ease",
                    height: "100%",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow =
                      "0 15px 40px rgba(91, 75, 136, 0.2)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 30px rgba(91, 75, 136, 0.1)";
                  }}
                >
                  <Link
                    to={`${item.redirectUrl ?? "/shop"}`}
                    style={{
                      display: "block",
                      height: "100%",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        overflow: "hidden",
                        borderRadius: "20px",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={item.imageUrl}
                        alt={item.alt}
                        style={{
                          width: "100%",
                          height: "auto",
                          display: "block",
                          transition: "transform 0.3s ease",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          background:
                            "linear-gradient(180deg, rgba(91, 75, 136, 0) 0%, rgba(91, 75, 136, 0.1) 100%)",
                          transition: "opacity 0.3s ease",
                        }}
                      />
                    </div>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
        <style>
          {`
            @keyframes float {
              0% { transform: translateY(0px) rotate(0deg); }
              50% { transform: translateY(-20px) rotate(10deg); }
              100% { transform: translateY(0px) rotate(0deg); }
            }
          `}
        </style>
      </section> */}
      {/* Advertisement section end */}

      {/* Biscuits Snacks section start*/}
      {/* <BiscuitsSnacksSlider sliderData={memoizedData.sliderData} /> */}
      {/* Biscuits Snacks section end */}

      {/* Testimonial section start*/}
      {/* <TestimonialSlider /> */}
      {/* Testimonial section end*/}

      {/* Global Delivery section start */}
      <section
        className="global-delivery-sec tp-space"
        style={{
          background: "linear-gradient(135deg, #fff 0%, #faf7ff 100%)",
          padding: "70px 0",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Video background */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            overflow: "hidden",
            pointerEvents: "none",
          }}
        >
          <video
            autoPlay
            muted
            loop
            playsInline
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              objectFit: "cover",
              opacity: 0.5,
            }}
          >
            <source src={GlobalDelivery} type="video/mp4" />
            {/* Fallback background pattern if video fails to load */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                opacity: 0.03,
                backgroundImage:
                  "radial-gradient(#3c3260 1px, transparent 1px)",
                backgroundSize: "20px 20px",
              }}
            />
          </video>
        </div>

        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div
                style={{
                  position: "relative",
                  borderRadius: "30px",
                  overflow: "hidden",
                  boxShadow: "0 20px 40px rgba(91, 75, 136, 0.15)",
                }}
              >
                {/* Overlay gradient */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background:
                      "linear-gradient(45deg, rgba(91, 75, 136, 0.2) 0%, rgba(91, 75, 136, 0) 100%)",
                  }}
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div
                style={{
                  padding: "40px",
                  background: "rgba(255, 255, 255, 0.5)",
                  borderRadius: "20px",
                  boxShadow: "0 10px 30px rgba(91, 75, 136, 0.1)",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <span
                  style={{
                    color: "#3c3260",
                    fontSize: "14px",
                    fontWeight: "600",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "15px",
                  }}
                >
                  <i className="fas fa-globe-americas"></i>
                  GLOBAL REACH
                </span>

                <h2
                  style={{
                    fontSize: "36px",
                    fontWeight: "700",
                    marginBottom: "20px",
                    color: "#333",
                  }}
                >
                  Delivering Sweet Moments
                  <span style={{ color: "#3c3260" }}> Across the Globe</span>
                </h2>

                <div
                  style={{
                    width: "60px",
                    height: "3px",
                    background: "#3c3260",
                    marginBottom: "25px",
                  }}
                />

                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "1.8",
                    color: "#333",
                    marginBottom: "30px",
                    fontWeight: "600",
                  }}
                >
                  From our kitchen to your doorstep, anywhere in the world. We
                  take pride in sharing our delicious treats with sweet lovers
                  worldwide, ensuring every package arrives fresh and
                  delightful.
                </p>

                <div className="row g-4">
                  {[
                    {
                      icon: "fas fa-plane",
                      title: "International Shipping",
                      text: "Worldwide delivery options",
                    },
                    {
                      icon: "fas fa-box",
                      title: "Secure Packaging",
                      text: "Temperature-controlled boxes",
                    },
                    {
                      icon: "fas fa-clock",
                      title: "Express Delivery",
                      text: "Quick & efficient service",
                    },
                    {
                      icon: "fas fa-shield-alt",
                      title: "Quality Guaranteed",
                      text: "Fresh arrival assured",
                    },
                  ].map((feature, index) => (
                    <div key={index} className="col-md-6">
                      <div
                        style={{
                          background: "rgba(255, 255, 255, 0.95)",
                          padding: "25px",
                          borderRadius: "15px",
                          boxShadow: "0 10px 30px rgba(91, 75, 136, 0.1)",
                          height: "100%",
                          transition:
                            "transform 0.3s ease, box-shadow 0.3s ease",
                          cursor: "pointer",
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.transform = "translateY(-5px)";
                          e.currentTarget.style.boxShadow =
                            "0 15px 40px rgba(91, 75, 136, 0.2)";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow =
                            "0 10px 30px rgba(91, 75, 136, 0.1)";
                        }}
                      >
                        <i
                          className={`${feature.icon} fa-2x mb-3`}
                          style={{ color: "#3c3260" }}
                        ></i>
                        <h5
                          style={{
                            fontSize: "18px",
                            marginBottom: "8px",
                            color: "#333",
                            fontWeight: "600",
                          }}
                        >
                          {feature.title}
                        </h5>
                        <p
                          style={{
                            fontSize: "14px",
                            color: "#444",
                            margin: 0,
                            fontWeight: "500",
                          }}
                        >
                          {feature.text}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Floating decorative elements */}
        <div
          style={{
            position: "absolute",
            top: "10%",
            right: "5%",
            animation: "float 6s ease-in-out infinite",
            opacity: 0.1,
          }}
        >
          <i
            className="fas fa-paper-plane fa-3x"
            style={{ color: "#3c3260" }}
          ></i>
        </div>
        <div
          style={{
            position: "absolute",
            bottom: "10%",
            left: "5%",
            animation: "float 8s ease-in-out infinite",
            opacity: 0.1,
          }}
        >
          <i
            className="fas fa-map-marker-alt fa-3x"
            style={{ color: "#3c3260" }}
          ></i>
        </div>
      </section>
      {/* Global Delivery section end */}
    </>
  );
};

export default Home;
